import { useSyncExternalStore } from "react";
import { tokenManager } from "lib/tokenManager";

export const useIsUserLoggedIn = () => {
    const token = useSyncExternalStore(tokenManager.subscribe, tokenManager.get);
    return token !== null;
};
